export default {
  image: 'Kapsel_2_2.png',
  pdf: '220829_WA-MIWO_021_Kapsel2_2_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-MIWO-021',
    technicalValues: {
      soundReductionIndex: {
        output: '54,1',
        value: 54.1
      },
      heatTransferCoefficient: {
        output: '0,15',
        value: 0.15
      },
      fireBehavior: {
        output: 'nichtbrennbar (A2-s1, d0)',
        value: 'A1A2'
      },
      fireResistanceOuter: {
        output: 'F 90-B / K\u208260' ,
        value: 'F-90-B-K260'
      },
      fireResistanceInner: {
        output: 'F 90-B / K\u208260' ,
        value: 'F-90-B-K260'
      }
    },
    name: 'Wandaufbau mit Mineralwolle l Aufbau 21',
    construction: {
      composition: [
        {
          output: 'mineralischer Unterputz',
          type: 'render',
          title: { de: 'Putz' },
          value: 'min-1'
        },
        {
          output: '60 mm Sto-Speedlamelle Typ ll',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'msp-60'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: 'opg-12'
        },
        {
          output: '60/200',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-200'
        },
        {
          output: '200 mm Steinwolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cirw-200'
        },
        {
          output: '15 mm Gipsfaserplatte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'ig-15'
        },
        {
          output: '18 mm Gipsfaserplatte',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: 'iq-18'
        }, 
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '314,5',
        value: 314.5
      }
    }
  }
}
